var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.4662 0L22.75 11.0683L34.0337 0L37.5 3.4075L22.75 17.9075L8 3.4075L11.4662 0Z"}));
}

Arrow.defaultProps = {"width":"46","height":"34","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
